module.exports = __webpack_public_path__ + "img/pic-coin@2x.cc924740.png";